// React-Screen CCancelClosedBonMode ("Stornogrund" fuer einen bereits
// ABGESCHLOSSENEN Bon) - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
//
// ENTSCHALT am 23.8.2026. Der Screen benutzt dasselbe Overlay-Geruest wie
// CCancelBonMode (POS.xmlForBonOverlay) und dasselbe Knopf-Raster
// (CPagedPushPanel) - beides rendert jetzt React. Die Stornogruende sind
// hier fest verdrahtet (-2/-3 aus Trans.getCancelText), nicht aus der DB.
// Die Methoden bleiben ueber spec.legacyMethods WOERTLICH uebernommen; sie
// fassen kein DOM an, sondern rechnen und schreiben (Bridge-Vertrag 8).
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';
import { Caption, PagedPushPanel, verdrahtePagedPushPanel } from '../widgets.jsx';

const legacy = {};

legacy.setReason = function (component, parameters) {
	var me = POS.getComponentById(parameters[0]);
	me.reasonId = parameters[1];
	me.reason = parameters[2];

	me.Main.BonManager.isPostCancelled = true;
	$.when(Trans.isPaydown(me.bonId)).then(function (val) {
		me.Main.BonManager.isPaydown = val;
		$.when(me.Main.BonManager.cancelBon(me.reasonId, me.reason, me.bonId, "cancellation")).done(function () {
			$.when(me.updateBonTS()).done(function () {
				me.Main.vacuumInfoValue(me.Main);
				$.when(me.Main.BonManager.copyBon(me.bonId)).done(function () {
					$.when(me.getTotalAmount()).done(function (totalAmount) {
						$.when(me.Main.BonManager.addEntryCDS(totalAmount, me.bonId)).done(function () {

							if (me.reasonId == -2)
								var text = POS.lang.getText("MESSAGES", "INFO_POSTCANCEL_TOO_MUCH_PAID");
							else
								text = POS.lang.getText("MESSAGES", "INFO_POSTCANCEL_CHANGE");
							POS.message.show(text, "info", "OK");

							log.add(4, "Info", "Cancel closed bon mode out", "");
							me.doFinish(me);
						});
					});
				});
			});
		});
	});
}

legacy.getTotalAmount = function () {
	var cls = new CBonManager();
	var defret = $.Deferred();
	cls.Main = this.Main;
	$.when(cls.loadFromId(this.bonId)).done(function () {
		// $.when(cls.loadFromId(this.bonId)).then(function () {
		var sums = cls.getSumArray();
		defret.resolve(sums[4] - sums[6]);
	});
	return defret.promise();
}

legacy.updateBonTS = function () {
	/*privMan.enablePrivilege (privList);*/

	var d = new Date();
	var timestamp = (d / 1000).toFixed(0);

	var sql = "UPDATE BON SET End = " + timestamp + " WHERE BON_ID = " +
		this.bonId;

	return POS.SQLiteCon.execute(sql);
}

legacy.finish = function (component, parameters) {
	var me = POS.getComponentById(parameters[0]);
	me.doFinish(me);
}

legacy.doFinish = function (me) {
	me.removeMe();
}


function CCancelClosedBonModeScreen({ bridge }) {
  const t = bridge.t;

  // Die zwei Stornogruende, woertlich aus dem alten makePagedPanel.
  const knoepfe = ['-2', '-3'].map((id) => {
    const grund = Trans.getCancelText(Number(id));
    return {
      text: grund,
      handler: (component, parameters) => bridge.setReason(component, parameters),
      param0: bridge.id,
      param1: id,
      param2: grund,
    };
  });

  return (
    <>
      {/* wholeOverlay - im Legacy das einzige Teil, dessen Sichtbarkeit
          prepare() ausdruecklich gesetzt hat (.CashWindow ist unsichtbar). */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay"
           style={{ position: 'absolute', visibility: 'visible' }} />
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }} />
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }} />
      <Caption bridge={bridge} pfad="3" addclass="titletext"
               text={t('LABELS', 'CANCEL_REASON_MODE')} />
      <Caption bridge={bridge} pfad="4" addclass="contenttext"
               text={t('LABELS', 'CANCEL_REASON_MODE_TEXT')} style={{ fontSize: '15px' }} />
      <Caption bridge={bridge} pfad="5" addclass="pricetext" text=" "
               style={{ fontSize: '32px', textAlign: 'right', top: '60px' }} />
      <Caption bridge={bridge} pfad="6" addclass="unitstext" text=" " />
      {/* okButton: bleibt unsichtbar und ohne Handler */}
      <div {...bridge.widget('7', 'CPushButton', {
             events: { onMousedown: true, onMouseout: true, onMouseup: true },
             proto: CPushButton.prototype,
           })}
           className="CPushButton okbutton" style={{ visibility: 'hidden' }}>
        <Caption bridge={bridge} pfad="7:0" text=" " />
      </div>
      {/* backButton -> finish */}
      <div {...bridge.widget('8', 'CPushButton', {
             events: { onMousedown: bridge.finish, onMouseout: true, onMouseup: true },
             attributes: { onMousedown_parameter_0: bridge.id },
             proto: CPushButton.prototype,
           })}
           className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined" />
      </div>
      {/* selectPanel: Spalten 2 wie im alten makePagedPanel, Zeilen 3 aus
          LYT_bonOverlayPagedPanel.xml */}
      <PagedPushPanel bridge={bridge} pfad="9" zeilen={3} spalten={2} knoepfe={knoepfe} />
    </>
  );
}

export const CCancelClosedBonMode = defineReactScreen({
  className: 'CCancelClosedBonMode',
  addclass: 'CCancelClosedBonMode CashWindow',
  htmlType: 'div',
  Screen: CCancelClosedBonModeScreen,
  // bonId setzt der Aufrufer zwischen Konstruktion und draw() - deshalb
  // fields() und nicht prepare().
  fields: () => ({
    bonId: null,
  }),
  // Nach dem Mount nur noch VERDRAHTUNG: Name wie in der XML und die Seiten
  // des Knopf-Rasters verketten.
  mountLegacy(bridge) {
    bridge.nameComponent('9', 'selectPanel');
    verdrahtePagedPushPanel(bridge, '9');
  },
  legacyMethods: legacy,
});
